<template>
    <requisicoes
        :dataServicos="obterDataServicos()"
        rotaDetalhar="Gescon_Gestores_Requisicoes_Detalhar"
        rotaListagem="Gescon_Gestores_Requisicoes"
    ></requisicoes>
</template>

<script>
import RequisicoesServicos from './RequisicoesServicos'
import Requisicoes from '../../contratos/requisicoes/Requisicoes'

export default {
    methods: {
        obterDataServicos() {
            return RequisicoesServicos
        }
    },

    components: {
        Requisicoes
    }
}
</script>
